import { useWebBooking } from "api/api-hooks/use-web-booking";
import { findRuleIdMissingMenuSelection } from "utils/required-menu-selection";

/**
 * Rule id of a booked activity whose required menu selection is still missing, or undefined
 * when the booking can be completed.
 *
 * Returns undefined while the booking is loading, so the guest is never blocked (or shown
 * the blocking message) on the strength of data we do not have yet.
 */
export const useMissingMenuSelection = (): number | undefined => {
    const { data: booking, isPending, isLoading } = useWebBooking();

    if (isPending || isLoading) return undefined;

    return findRuleIdMissingMenuSelection(booking);
};
